import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackMetaPageView } from "./index";

/**
 * Fires a Meta Pixel PageView on SPA route changes. The first run is skipped
 * because the landing-page PageView is fired by initMetaPixel when the pixel
 * loads, so each page is counted exactly once.
 */
export function useMetaPixelPageViews(): void {
  const location = useLocation();
  const isFirstRun = useRef(true);

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }
    trackMetaPageView();
  }, [location.pathname]);
}
